import React from 'react';
import {Link} from 'react-router-dom';

const STATUS_COLORS = {
  NEW: 'bg-blue-100 text-blue-800',
  PENDING_FULFILLMENT: 'bg-yellow-100 text-yellow-800',
  FULFILLED: 'bg-green-100 text-green-800',
  CANCELLED: 'bg-red-100 text-red-800',
};

const CHANNEL_COLORS = {
  EBAY: 'bg-purple-100 text-purple-800',
  WEBSITE: 'bg-indigo-100 text-indigo-800',
  AMAZON: 'bg-orange-100 text-orange-800',
};

export default function RecentOrders({ orders = [] }) {
  const recent = [...orders]
    .sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''))
    .slice(0, 5);

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b">
        <h2 className="text-lg font-semibold text-gray-900">Recent Orders</h2>
      </div>
      <div className="p-6">
        {recent.length === 0 ? (
          <p className="text-gray-500 text-center py-6">No orders yet.</p>
        ) : (
          <table className="w-full">
            <thead>
              <tr className="text-left text-sm text-gray-500">
                <th className="pb-3">Order ID</th>
                <th className="pb-3">Channel</th>
                <th className="pb-3">Status</th>
                <th className="pb-3 hidden md:table-cell">Created</th>
              </tr>
            </thead>
            <tbody>
              {recent.map((order) => (
                <tr key={order.id} className="border-t">
                  <td className="py-3">
                    <Link to={`/inventory/orders/${order.id}`} className="text-red-600 hover:text-red-800">
                      {order.externalOrderId || order.id.substring(0, 8)}
                    </Link>
                  </td>
                  <td className="py-3">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${CHANNEL_COLORS[order.channel] || 'bg-gray-100 text-gray-800'}`}>
                      {order.channel}
                    </span>
                  </td>
                  <td className="py-3">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${STATUS_COLORS[order.status] || 'bg-gray-100 text-gray-800'}`}>
                      {order.status.replace(/_/g, ' ')}
                    </span>
                  </td>
                  <td className="py-3 text-gray-600 hidden md:table-cell">
                    {new Date(order.createdAt).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
